import React, { useState, useEffect, useContext, useReducer } from "react";
import {
  Button,
  Center,
  Box,
  Text,
} from "@chakra-ui/react";
import { useRouter } from "next/dist/client/router";
import { color, textStyle, variant } from "theme/names";

export const GetExtension = ({}) => {
    
    const router = useRouter();

    return (
        <Center flexDirection="column" mt={10}>
            <Text fontSize="lg" fontWeight={600}>Download extension to continue</Text>
            <Box pb={6} mt={5} textAlign="center">
                <Text textStyle={textStyle["body.medium.light"]}>
                    This action requires that you download the Taplio Chrome Extention.
                </Text>
                <Text textStyle={textStyle["body.medium.light"]} mt={4}>
                    It's a safe and simple step to enjoy 100% of the app.
                </Text>
            </Box>
            <Button
                onClick={() => {
                    router.push("/connect");
                }}
                variant={variant.Button.primary}
            >
                Get Taplio Extension
            </Button>
        </Center>
    )
}